import React from 'react'
import './main.css';
import Projects from './projects';
import Skills from './skills';
import Design from './designs';
import Contact from './contact';


export default function main() {

    // Function to handle button click
    const handleClick = () => {
      // You can log or perform any action when the button is clicked
      console.log('CV Download button clicked!');
      // Optionally, trigger the download manually if needed
      window.location.href = "https://drive.google.com/file/d/1tDJk_XImqa6OxujtUp2Z63B_k-GrRyIX/view?usp=sharing";
    }
  
  return (
    <div>

      <div className='intro'>
        <h2 className='hola'>Hey !<br/> I'm Buthmi Kaveesha </h2>
          <p className='about'> Frontend developing | UI UX Designing <br/><br/>
         Enthusiastic with searching problems and give solutions in differnt way.<br/>
          <br/>UG SLIIT - BSc (Hons) in Information Technology Specializing in Information Technology</p>
          <Skills></Skills>
            
          < a href ="https://drive.google.com/file/d/1tDJk_XImqa6OxujtUp2Z63B_k-GrRyIX/view?usp=sharing" class="no-underline">  
                 <button style={{ marginTop: '60px', marginRight: '50px' }}className='cv-download' onClick={handleClick}> Download CV </button><br/><br/>
             </a>
      </div>
      
      <br/>
     
  


        <div className='projects'>
          <h1>University Projects</h1>
          <Projects></Projects>
        
        </div>
        <div className='designs'>
          <h1>UI Designs</h1>
          <Design></Design>
          
           {/* <img src={img1} className="img" alt="logo" />  */}
      <br/>
        </div>
        <div className='contact'>
          <h2>Let's Connect <Contact></Contact></h2>
        </div>
       
        <hr></hr>
      

      
    </div>
  )
}
